import { createAction, props } from '@ngrx/store';
import { AutogeneratedEnvelopeDto } from '../../api/models/autogenerated-envelope-dto.model';

export const loadAutosentEnvelope = createAction(
    '[AUTOSEND ENVELOPE] Load Autosent Envelope',
    props<{ contractId: number }>()
);

export const loadAutosentEnvelopeSuccess = createAction(
    '[AUTOSEND ENVELOPE] Load Autosent Envelope Success',
    props<{ envelope: AutogeneratedEnvelopeDto }>()
);

export const loadAutosentEnvelopeFailure = createAction(
    '[AUTOSEND ENVELOPE] Load Autosent Envelope Failure',
    props<{ error: any }>()
);

export const autosentEnvelopeSignalReceived = createAction(
    '[AUTOSEND ENVELOPE] Autosent Envelope Signal Received',
    props<{ envelope: AutogeneratedEnvelopeDto }>()
);

export const listenForAutosentEnvelopeSignal = createAction('[AUTOSEND ENVELOPE] Listen For Autosent Envelope Signal');
